import { SaveButton } from '@/components/refinedev/action_buttons';
import DepartmentForm from './department-form';
import CreateForm from '@/components/refinedev/pages/create-form';

const DepartmentCreate = () => {
  return (
    <CreateForm transformBeforeSave={DepartmentForm.transformBeforeSave}>
      <DepartmentForm />
      <SaveButton/>
    </CreateForm>
  );
};

export default DepartmentCreate;
